<div *ngIf="initialised">
  <div class="row">
    <h2 class="d-none d-md-block col-4"><span *ngIf="!isCollexusGraphs()">Overview.</span></h2>
    <h2 class="d-none d-md-block col">Your debts.</h2>
  </div>
  <div class="row">
    <div class="col-12 col-md-4">
      <h2 *ngIf="!isCollexusGraphs()" class="d-block d-md-none">Overview.</h2>
      <div class="card debt-summary-card">
        <div class="card-body">
            <div *ngIf="isCollexusGraphs()" class="w-100 d-flex flex-wrap justify-content-center">
              <kendo-arcgauge [value]="getTotalDebt() - getTotalOutstanding()" [scale]="{ max: getTotalDebt() }" [color]="getCircleGaugeColour()">
                <ng-template kendoArcGaugeCenterTemplate>
                  <p class="mb-0"><b>Outstanding</b></p>
                  <h3 class="mb-3"><b>{{getTotalOutstandingFormatted()}}</b></h3>
                </ng-template>

                <kendo-arcgauge-scale [startAngle]="0" [endAngle]="180" [majorUnit]="getTotalDebt()" [majorTicks]="{ visible: true, color: getCircleGaugeColour() }">
                  <kendo-arcgauge-scale-labels format="c" [color]="getCircleGaugeColour()" [visible]="true" [content]="getScaleLabelContent.bind(getTotalPaidFormatted())">
                  </kendo-arcgauge-scale-labels>
                </kendo-arcgauge-scale>
              </kendo-arcgauge>
            </div>

            <div *ngIf="!isCollexusGraphs()" class="w-100 d-flex flex-wrap justify-content-center">
              <kendo-circulargauge class="circle-gauge" [value]="getTotalOutstanding() / (getTotalDebt() / 100)" [color]="getCircleGaugeColour()">
                <ng-template kendoCircularGaugeCenterTemplate>
                  <h3 class="mb-0"><b>{{getTotalOutstandingFormatted()}}</b></h3>
                  <p class="bold mb-0">Outstanding</p>
                </ng-template>
              </kendo-circulargauge>
            </div>
            <div *ngIf="!isCollexusGraphs()" class="w-100 d-none d-md-flex flex-wrap justify-content-between mt-2">
              <div class="bold">Outstanding</div>
              <div></div>
              <div>{{getTotalOutstandingFormatted()}}</div>
              <kendo-progressbar class="w-100" [min]="0" [max]="getTotalDebt()" [value]="getTotalOutstanding()" [label]="{visible: false}">
              </kendo-progressbar>
            </div>
            <div *ngIf="!isCollexusGraphs()" class="w-100 d-none d-md-flex flex-wrap justify-content-between mt-2">
              <div class="bold">Paid</div>
              <div></div>
              <div>{{getTotalPaidFormatted()}}</div>
              <kendo-progressbar class="w-100" [min]="0" [max]="getTotalDebt()" [value]="getTotalPaid()" [label]="{visible: false}">
              </kendo-progressbar>
            </div>
            <div *ngIf="!isCollexusGraphs()" class="w-100 d-none d-md-flex flex-wrap justify-content-between mt-2">
              <div class="bold">Original debt</div>
              <div></div>
              <div>{{getTotalDebtFormatted()}}</div>
              <kendo-progressbar class="w-100" [min]="0" [max]="getTotalDebt()" [value]="getTotalDebt()" [label]="{visible: false}">
              </kendo-progressbar>
            </div>

            <div [ngSwitch]="debtScenario" class="w-100 d-inline-block d-md-none text-center">
              <div *ngSwitchCase="'OS'">
                <button *ngIf="isPaymentButtonsVisible()" kendoButton class="button-primary w-100" [routerLink]="'/payment/payinfull'">
                  Make a payment
                </button>
                <button *ngIf="isPaymentButtonsVisible()" kendoButton class="button-primary w-100" [routerLink]="'/payment/paybyarrangement'">
                  Setup a payment plan
                </button>
              </div>
              <div *ngSwitchCase="'PP'">
                <button *ngIf="isPaymentButtonsVisible()" kendoButton class="button-primary w-100" [routerLink]="'/payment/payinfull'">
                  Make a payment
                </button>
                <p class="mt-4">
                  <span class="bold">On payment plan</span>
                  <br>
                  <a *ngIf="isPaymentButtonsVisible()" [routerLink]="'/payment/paybyarrangement'"><span class="bold">Update payment plan</span></a>
                </p>
              </div>
              <div *ngSwitchCase="'MIX'">
                <p class="bold mt-2">
                  {{getTotalOutstandingNotOnPlanFormatted()}} not on payment plan
                </p>
                <button *ngIf="isPaymentButtonsVisible()" kendoButton class="button-primary w-100" [routerLink]="'/payment/payinfull'">
                  Make a payment
                </button>
                <button *ngIf="isPaymentButtonsVisible()" kendoButton class="button-primary w-100" [routerLink]="'/payment/paybyarrangement'">
                  Add to payment plan
                </button>
              </div>
            </div>
        </div>
      </div>
    </div>

    <div class="col">
      <h2 class="d-block d-md-none mt-4">Your debts.</h2>
      <div class="card debt-summary-card">
        <div class="card-body">
          <div class="card-title d-flex flex-wrap align-items-center">
            <h3 class="mb-0 me-4">Outstanding <span class="bold">{{getTotalOutstandingWithCurrency()}}</span></h3>
            <div class="debt-button-container">
              <button *ngIf="isPaymentButtonsVisible()" kendoButton class="button-primary me-md-4" [routerLink]="'/payment/payinfull'">Make a payment</button>
              <button *ngIf="isPaymentPlanButtonVisible()" kendoButton class="button-primary" [routerLink]="'/payment/paybyarrangement'">Setup a payment plan</button>
            </div>
          </div>

          <table class="table-stackable">
            <thead class="">
              <tr>
                <th>Original creditor</th>
                <th>Balance</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let account of getDebtorAccounts()">
                <td data-th="Original creditor">{{account.portfolioDesc}}</td>
                <td data-th="Balance">{{formatCurrency(account.totalOutstanding)}}</td>
                <td data-th="Status">{{account.statusDesc}}</td>
                <td class="button-td">
                  <button kendoButton *ngIf="isAddPaymentPlanButtonVisible(account)" class="button-primary" [routerLink]="'/payment/paybyarrangement'">Add to payment plan</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <p *ngIf="isPaymentPlanLinkVisible()" class="mt-2">
        <a [routerLink]="'/payment/paybyarrangement'"><span class="bold">Update payment plan</span></a>
      </p>

    </div>
  </div>
</div>